import React from 'react';
import { NodesContext } from '@beefco/sdk-shared';
var debugTreeSlice = process.env.NODE_ENV !== 'production' ? {
  getNode: function getNode() {
    throw new Error('Попытка вызова getNode до инициализации NodesTree, возможно нужна проверка на готовность coreDSL');
  },
  get rootNodeIds() {
    throw new Error('Попытка вызова rootNodeIds до инициализации NodesTree, ' + 'возможно нужна проверка на готовность coreDSL');
  }
} : {};
var useNodeTreeSlice = function useNodeTreeSlice(nodeTree, size) {
  return React.useMemo(function () {
    if (!nodeTree) return debugTreeSlice;
    var slice = nodeTree.getTreeSlice({
      size: size
    });
    var _ref = slice || {},
      getNode = _ref.getNode,
      getRootIds = _ref.getRootIds;
    var rootNodeIds = getRootIds();
    return {
      getNode: getNode,
      rootNodeIds: rootNodeIds
    };
  }, [nodeTree, size]);
};
export var NodesProvider = function NodesProvider(_ref2) {
  var nodeTree = _ref2.nodeTree,
    size = _ref2.size,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(NodesContext.Provider, {
    value: useNodeTreeSlice(nodeTree, size)
  }, children);
};